export default "__VITE_ASSET__6692d6d9__"